import { takeLatest } from 'redux-saga/effects';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../redux/reducers';
import { autopublish } from './autopublish';

export function* autopublishSagas() {
  yield takeLatest([LOAD_PUBLISH_TERMS_SUCCESS], autopublish);
}
